<template>
  <div class="maskBox">
    <div class="NoSpinChancesYet">
      <div class="title">{{$t('lang.cashWheel.getReceived')}}</div>
      <div class="chanceBox">
        <slot>
          <!--        <img src="../../assets/images/cashWheel/chanceIcon.png" class="chanceIcon" alt="">-->
          <!--        <div class="chanceNum">X{{chanceNum}}</div>-->
        </slot>
      </div>
<!--      <div class="tip">{{$t('lang.cashWheel.goTryYourLuck')}}</div>-->
      <div class="Btn" @click="close">{{$t('lang.cashWheel.get')}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modalBox-getChance',
  props: {
    'receivedValue': {
      type: Number,
      default: 0
    }
  },
  data () {
    return {}
  },
  methods: {
    close () {
      this.$emit('closeModalBoxGetReceived')
    }
  }
}
</script>

<style lang="less" scoped>
.maskBox{
  height: 100vh;
  width: 100%;
  position: fixed;
  background-color: rgba(0,0,0,0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}
@keyframes expandBox {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.NoSpinChancesYet{
  width: 82.233vw;
  height: 66.94vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  animation: expandBox 0.2s ease-in-out forwards;
  border: 1px solid #888888;
  border-right: 2px solid #888888;
  border-left: 2px solid #888888;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(8px);
  border-radius: 1.243vw;
  .title{
    width: 34.27vw;
    color: #D9D9D9;
    font-size: 5.277vw;
    font-weight: 700;
    text-align: center;
    position: relative;
    top: 4vw;
    line-height: 6vw;
  }
  .Btn{
    width: 65.913vw;
    height: 10.833vw;
    color: #000000;
    font-size: 4.44vw;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    top: 12vw;
    background: linear-gradient(90deg, #01B7D3 0%, #13C498 100%), #F1DAB0;
    border-radius: 1.388vw;
  }
  .chanceBox{
    height: 21.388vw;
    width: 65.913vw;
    background-color: #2C2C2E;
    border-radius: 1.5vw;
    position: relative;
    top: 6vw;
    display: flex;
    align-items: center;
    justify-content: center;
    color: transparent;
    background-image: linear-gradient(to left, #F0D55E 0%, #E2D173 46%,  #E2D173 50%, #E1A959 68%, #E2D173 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 6.94vw;
    font-weight: 700;
  }
  .tip{
    font-size: 3.61vw;
    color: #DFDFDF;
    position: relative;
    top: 9vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/cashWheel/modalBox-getReceived.vue